const getRemoveTooltip = (isSingle: boolean): string => isSingle ? 'clear assignment' : 'remove conditional assignment';

const getConfirmRemoveMessage = (isSingle: boolean): string => {

    return `Are you sure you want to ${getRemoveTooltip(isSingle)}?`;
};

export { getRemoveTooltip, getConfirmRemoveMessage };
